export function initTocObserver(): void {
  const tocItems = document.querySelectorAll<HTMLElement>(".p-breezy-goal-2026__panel-toc-item[data-toc]");
  if (!tocItems.length) return;

  const sectionMap = new Map<Element, HTMLElement>();

  tocItems.forEach((item) => {
    const id = item.dataset.toc;
    if (!id) return;
    const section = document.getElementById(`toc-${id}`);
    if (section) sectionMap.set(section, item);
  });

  if (!sectionMap.size) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const item = sectionMap.get(entry.target);
        if (!item) return;
        const link = item.querySelector<HTMLElement>(".p-breezy-goal-2026__panel-toc-link");
        if (link) link.classList.toggle("is-active", entry.isIntersecting);
      });
    },
    { threshold: 0.15 }
  );

  sectionMap.forEach((_, section) => observer.observe(section));
}
